export default "__VITE_ASSET__e82776fc__"